import { z } from 'zod';
import {
  TenantIdSchema,
  UlidSchema,
  MontoClpSchema,
  IsoTimestampSchema,
} from './common.js';

/**
 * Pago — intento de liquidación de uno o más CargoUnidad por parte de un residente.
 * Un pago puede cubrir múltiples cargos (split) pero en MVP asumimos 1:1.
 */

export const MedioPagoSchema = z.enum(['khipu', 'webpay_plus', 'transferencia_manual']);
export type MedioPago = z.infer<typeof MedioPagoSchema>;

export const EstadoPagoSchema = z.enum([
  'iniciado',
  'pendiente_reconciliacion',
  'reconciliado',
  'rechazado',
  'expirado',
]);
export type EstadoPago = z.infer<typeof EstadoPagoSchema>;

export const PagoSchema = z.object({
  id: UlidSchema,
  tenantId: TenantIdSchema,
  cargoUnidadId: UlidSchema,
  residenteId: UlidSchema,
  monto: MontoClpSchema,
  medio: MedioPagoSchema,
  estado: EstadoPagoSchema,
  /** Referencia externa del gateway (mock en MVP). */
  referenciaExterna: z.string().nullable(),
  /** URL de redirección al gateway (mock en MVP). */
  redirectUrl: z.url().nullable(),
  iniciadoAt: IsoTimestampSchema,
  reconciliadoAt: IsoTimestampSchema.nullable(),
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
});
export type Pago = z.infer<typeof PagoSchema>;

export const IniciarPagoRequestSchema = z.object({
  cargoUnidadId: UlidSchema,
  medio: MedioPagoSchema,
  returnUrl: z.url(),
});
export type IniciarPagoRequest = z.infer<typeof IniciarPagoRequestSchema>;

export const IniciarPagoResponseSchema = z.object({
  pagoId: UlidSchema,
  redirectUrl: z.url(),
  expiresAt: IsoTimestampSchema,
});
export type IniciarPagoResponse = z.infer<typeof IniciarPagoResponseSchema>;
